module.exports = __webpack_public_path__ + "img/ryzs12.c9c633ee.jpg";